import axios from "axios";
import {
  handleError,
  handleInfo,
  handleSuccess,
  handleSuccessOne,
  handleErrorOne,
  createFormData,
} from "@store/action/GlobalAction";
var controller = new AbortController();
var signal = controller.signal;

const URL = process.env.REACT_APP_MICRO_MULTIMEDIA_URL;
const radio_id = localStorage.getItem("radio_id");

// ** Get all Data
export const getAllVideos = (params) => async (dispatch) => {
  await axios
    .get(`${URL}/videos/radio${params?.search ? params?.search : ""}`, {
      params: {
        per_page: params.per_page,
        page: params.page,
      },
    })
    .then((response) => {
      dispatch({
        type: "GET_ALL_VIDEOS",
        data: response.data.data?.data,
        totalPages: response.data.data?.total,
        params,
      });
    });
};
// ** Get data per id on page
export const getVideoById = (id) => async (dispatch) => {
  await axios.get(`${URL}/videos/${id}`).then((response) => {
    dispatch({
      type: "GET_VIDEO_ID",
      data: response.data.data[0][0],
    });
  });
};
// Post new Video
export const addVideo = (files, func, func1, params) => (dispatch) => {
  const config = {
    onUploadProgress: (progressEvent) => {
      let { loaded, total } = progressEvent;
      let percentComplete = loaded / total;
      percentComplete = parseInt(percentComplete * 100);
      func1(percentComplete);
    },
    signal,
  };
  axios
    .post(`${URL}/videos/upload`, createFormData(files), config)
    .then((res) => {
      dispatch({
        type: "ADD_VIDEO_SUCCESS",
        payload: res.data,
      });
      if (res.data.data.failed === 0) {
        handleSuccess(
          res.data.message,
          res.data.data.total,
          res.data.data.success
        );
      } else if (res.data.data.failed !== 0 && res.data.data.success !== 0) {
        handleInfo(
          res.data.message,
          res.data.data.total,
          res.data.data.success,
          res.data.data.failed
        );
      } else {
        handleError(
          res.data.message,
          res.data.data.total,
          res.data.data.failed
        );
      }
      func();
      dispatch(getAllVideos(params));
    })
    .catch((err) => {
      dispatch({
        type: "ADD_VIDEO_FAIL",
      });
    });
};
// ** edit data per id on page
export const editVideo = (id, info, func, params) => async (dispatch) => {
  await axios
    .put(`${URL}/videos/${id}`, info)
    .then((response) => {
      dispatch({
        type: "EDIT_VIDEO_SUCCESS",
        message: response.data.message,
      });
      func();
      handleSuccessOne(response.data.message);
      dispatch(getAllVideos(params));
    })
    .catch((err) => {
      if (err.response.data.message) {
        dispatch({
          type: "EDIT_VIDEO_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "EDIT_VIDEO_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
// ** delete data per id on page
export const deleteVideo = (id, params) => async (dispatch) => {
  await axios
    .delete(`${URL}/videos/${id}`)
    .then((res) => {
      if (res.data.code === 200) {
        handleSuccessOne(res.data.message);
        dispatch(getAllVideos(params));
      }
    })
    .catch((err) => {
      if (err.response) {
        handleErrorOne(err.response.data.message);
      }
    });
};
export const abordingRequest = (func) => {
  controller.abort("Request cancelled!");
  handleErrorOne(controller.signal.reason);
  func();
  controller = new AbortController();
  signal = controller.signal;
};

export const getCommentByVideoId = (id) => (dispatch) => {
  axios.get(`${URL}/video/comment/${id}?per_page=500`).then((response) => {
    dispatch({
      type: "GET_COMMENT_BY_VIDEO",
      Comments: response.data.data.data,
      totalPages: response.data.data?.data.length,
    });
  });
};
export const addCommentByVideo = (data, id, func) => (dispatch) => {
  axios
    .post(`${URL}/video/comment/${id}`, data)
    .then((res) => {
      dispatch({
        type: "ADD_COMMENT_VIDEO_SUCCESS",
        payload: res.data,
      });
      func();
      handleSuccessOne(res.data.message);
    })
    .catch((err) => {
      if (err.response) {
        dispatch({
          type: "ADD_COMMENT_VIDEO_FAIL",
          payload: err.response.data.message,
        });
        setTimeout(() => {
          dispatch({
            type: "ADD_COMMENT_VIDEO_FAIL",
            payload: null,
          });
        }, 3000);
      }
    });
};
export const getAllVideoComments = (params) => async (dispatch) => {
  await axios
    .get(`${URL}/video/allcomments`, {
      params: {
        per_page: params.per_page,
        page: params.page,
      },
    })
    .then((response) => {
      dispatch({
        type: "GET_ALL_VIDEO_COMMENTS",
        data: response.data.data,
        totalPages: response.data.data?.total,
      });
    });
};
export const EditStatusComment = (idpo, idcom, active, params) => {
  const data = {
    active: active,
  };
  return (dispatch) => {
    axios
      .put(`${URL}/video/comment/${idpo}/${idcom}`, data)
      .then((response) => {
        dispatch({
          type: "EDIT_STATUS_COMMENT_VIDEO_SUCCESS",
          payload: response.data,
        });
        {
          active === 0
            ? handleSuccessOne("comment status switched to Drafted ")
            : handleSuccessOne("comment status switched to Published");
        }
        dispatch(getAllVideoComments(params));
      })
      .catch((err) => {
        if (err.response) {
          dispatch({
            type: "EDIT_STATUS_COMMENT_VIDEO_FAIL",
            payload: err.response.data.message,
          });
          setTimeout(() => {
            dispatch({
              type: "EDIT_STATUS_COMMENT_VIDEO_FAIL",
              payload: null,
            });
          }, 3000);
        }
      });
  };
};
export const getLastVideo = () => (dispatch) => {
  axios.get(`${URL}/video/last/5/radio`).then((response) => {
    dispatch({
      type: "GET_LAST_VIDEO",
      Last: response?.data?.data,
    });
  });
};
